export default __webpack_public_path__ + "static/media/fNeutral17.880022c1.png";